import { Component,  ViewEncapsulation } from '@angular/core';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'app-capital-increase',
  templateUrl: './capital-increase.component.html',
  encapsulation:ViewEncapsulation.None,
  styleUrls: ['./capital-increase.component.scss']
})
export class CapitalIncreaseComponent  {

  isBrowser: boolean;
  faArrUp=faArrowUp;
  constructor() { }

}
